import * as types from './index';

export const activityLogListAction = (data) => {
    return {
    type: types.ACTIVITY_LOG_LIST,
    data
    }
};

